import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { CourseUnitsService } from 'src/app/services/course-units.service';
import { DocumentService } from 'src/app/services/document.service';
import { LearnerService } from 'src/app/services/learner.service';
import { PortfolioService } from '../../../services/portfolio/portfolio.service';
@Component({
  selector: 'app-learner-profile-form',
  templateUrl: './learner-profile-form.component.html',
  styleUrls: ['./learner-profile-form.component.scss']
})
export class LearnerProfileFormComponent implements OnInit {


  @Input('learners') learnersList;
  @Input('units') unitList

  @Output() lpFormData: EventEmitter<any> = new EventEmitter<any>();
  allLerners = []
  learnerForm
  unitsForm
  allUnits = []
  jobId: any;
  learnerId: any;
  courseId: any;
  courseType: any;
  unitsAdded: [];
  learnerFormDetails: any;
  isEdit: boolean = false;
  loading = false
  constructor(
    public formBuilder: FormBuilder,
    public _learnerService: LearnerService,
    public unitService: CourseUnitsService,
    private activatedRoute: ActivatedRoute,
    public documentService: DocumentService,
    private router: Router,
    public _snackBar: MatSnackBar,
    public _portfolioService: PortfolioService
  ) {

    this._learnerService.newLearnerObservable().subscribe((newLeaner) => {
      let learner = {
        // exam1: newLeaner.learner.exam1,
        // exam2: newLeaner.learner.exam2,
        name: newLeaner.learner.name,
        learnerId: newLeaner.learner._id
      }
      this.allLerners.push(learner)

      // this.getMarks()
    });

  }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(qparam => {
      if (qparam.jobId) {
        this.jobId = qparam.jobId
        this.getLearners(qparam.jobId)
      }
      if (qparam.learnerId) {
        this.learnerId = qparam.learnerId
        this.getLpDetails(qparam.learnerId)
      }
      if (qparam.courseId) {
        this.courseId = qparam.courseId

      }
      if (qparam.type) {
        this.courseType = qparam.type
        if (this.courseType != 'Level2') {
          this.getUnits()
        } else {
          this.getLevel2Units()
        }
      }
    })
    this.createForm()
    this.createUnitForm()
  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes.learnersList && changes.learnersList.currentValue) {
      console.log("what is the total learners list of job", changes.learnersList.currentValue);
      this.allLerners = changes.learnersList.currentValue
    }
    if (changes.unitList && changes.unitList.currentValue) {
      this.allUnits = changes.unitList.currentValue
      console.log("all units list in main page==============", this.allUnits);
      this.createUnitForm()
    }


  }




  createForm(details?) {
    this.learnerForm = new FormGroup({
      learnerName: new FormControl(details && details.learnerName ? details.learnerName : ''),
      medicalNeed: new FormControl(details && details.medicalNeed ? details.medicalNeed : ''),
      barriers: new FormControl(details && details.barriers ? details.barriers : ''),
      bksbEnglish: new FormControl(details && details.bksbEnglish ? details.bksbEnglish : ''),
      bksbMaths: new FormControl(details && details.bksbMaths ? details.bksbMaths : ''),
      teaching: new FormControl(details && details.teaching ? details.teaching : ''),
      pts: new FormControl(details && details.pts ? details.pts : ''),
      destinationData: new FormControl(details && details.destinationData ? details.destinationData : '')
    })

  }

  createUnitForm() {
    this.unitsForm = new FormGroup({
      units: this.formBuilder.array(this.multipleCourse(this.allUnits, this.unitsAdded))
      // unitTitle: new FormControl(''),
      // unitInput: new FormControl(''),
      // unitId: new FormControl('')
    })
  }


  multipleCourse(unitList, exitsUnit): Array<any> {
    console.log("exitsUnit", unitList)
    if (unitList && unitList.length) {
      let unitArray = []
      _.forEach(unitList, async (unit, index) => {
        await unitArray.push(new FormGroup({
          unitTitle: new FormControl(exitsUnit ? exitsUnit[index].unitTitle : unit.title),
          unitId: new FormControl(exitsUnit ? exitsUnit[index].unitId : unit._id),
          unitInput: new FormControl(exitsUnit ? exitsUnit[index].unitInput : ''),
        }))
      })
      return unitArray;


    }
    else {
      return [this.formBuilder.group({
        unitTitle: new FormControl(''),
        unitInput: new FormControl(''),
        unitId: new FormControl('')
      })]
    }
  }
  get multipleVisitorsGroup() { return <FormArray>this.unitsForm.get('units') }



  submitLearnerForm() {
    this.loading = true
    console.log("final value of unit form", this.unitsForm.value);
    // let finalObj = {
    let details = {
      leanerForm: this.learnerForm.value,
      units: this.unitsForm.controls['units'].value
    }
    // }
    let obj = {
      metaObj: {
        title: 'LP',
      },
      jobId: this.jobId,
      onModel: 'job',
      learnerId: details.leanerForm.learnerName,
      details: details
    }

    if (this.isEdit == true) {
      console.log("this is for edit record", this.learnerFormDetails);
      obj['documentMetaId'] = this.learnerFormDetails.documentMetaId._id
      obj['documentId'] = this.learnerFormDetails._id
      this.documentService.updateForm(obj)
      this.documentService.updateForm(obj).subscribe((response) => {
        console.log("response when lp form is update", response);

        this.handleSnackBar({ msg: "Document Update successfully!", button: "Ok" });
        this.router.navigate(['/jobs/' + this.jobId], { queryParams: { courseType: this.courseType, currentTab: 6 } })
        this.loading = false
      }, err => {
        console.log("error while update lp form", err);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong", button: "Ok" });
      })
    } else {
      console.log("this is for new record");

      this.documentService.addDocument(obj).subscribe((response) => {
        console.log("response of new lp document added", response);
        this.handleSnackBar({ msg: "Document saved successfully!", button: "Ok" });
        this.loading = false
        this.router.navigate(['/jobs/' + this.jobId], { queryParams: { courseType: this.courseType, currentTab: 6 } })
      }, err => {
        console.log("error while add lp ocument", err);
        this.loading = false
        this.handleSnackBar({ msg: "Something went wrong!", button: "Ok" });
      })
    }
  }


  // UTILITY



  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  // APIs

  getLearners(jobId) {
    this.loading = true
    this._learnerService.getLearnersByJobId(jobId).subscribe(responseLearner => {
      this.allLerners = responseLearner;
      console.log("***this.allLearners in job", this.allLerners);
      this.loading = false
    })
  }

  getUnits() {
    this.loading = true
    this.unitService.getUnits(this.courseId).subscribe(res => {
      this.unitList = res;
      this.allUnits = this.unitList;
      // this.unitsCopy = res;
      console.log("units list by course id", this.unitList)
      this.createUnitForm()
      this.loading = false

    })
  }

  getLpDetails(learnerId) {
    this.loading = true
    this.documentService.getLernerForm(learnerId).subscribe((response) => {
      console.log("response of learners list with form details", response);
      if (response && response.length) {
        this.learnerFormDetails = response[0]
        this.isEdit = true
        this.loading = false
        if (this.learnerFormDetails && this.learnerFormDetails.details && this.learnerFormDetails.details.leanerForm) {
          this.createForm(this.learnerFormDetails.details.leanerForm)
        }
        if (this.learnerFormDetails && this.learnerFormDetails.details && this.learnerFormDetails.details.units) {
          this.unitsAdded = this.learnerFormDetails.details.units
          console.log("in if form called")
          this.createUnitForm()
        } else {
          console.log("in else form called")
          this.createUnitForm()
        }


        console.log("response of learners list with form details", this.learnerFormDetails);
      }
    }, error => {
      this.loading = false
      console.log("error while get lp form list", error);
      this.openSnackBar("Something went wrong!", 'OK')
    })
  }

  getLevel2Units() {
    // this._portfolioService.getClassromGroupedByCourseId(this.courseId).subscribe(res => {
    this.unitList = []
    //   this.loading = false
    //   console.log('classroom grouped portfolio', res);
    //   if (res && res.length) {
    //     let assignment = res
    //     assignment.forEach((item) => {
    //       console.log("single item", item);
    //       item.session.forEach((singleAssign) => {
    //         let obj = {
    //           _id: singleAssign.sessionId,
    //           title: item._id + ": Unit-" + singleAssign.sessionUnit
    //         }
    //         let index = this.unitList.findIndex(function (o) { return o._id == singleAssign.sessionId })
    //         console.log("index of this element", index);
    //         if (index == -1) {
    //           this.unitList.push(obj)
    //         }
    //       })
    //     })

    //     this.allUnits = this.unitList
    //     this.createUnitForm()
    //     console.log("what is unit list", this.unitList);


    //   }
    // })


    this.unitService.getUnits(this.courseId).subscribe(res => {
      console.log("response of all status", res);
      let unitArray = []
      let newArray = res.filter((o) => {
        if (o.title == 'Track Maintenance' || o.title == 'Technical Certificate') {
          unitArray.push(o)
        }
      })
      console.log("display unit array", unitArray);
      // let finalArray = []

      unitArray.forEach((item) => {
        // let obj = {
        //   _id: item.title,
        //   session: []
        // }
        let obj = {
          _id: item._id,
          title: item.title + ": Unit-" + item.unitNo
        }
        // let index = finalArray.findIndex(x => x._id === item.title);
        let index = this.unitList.findIndex(function (o) { return o._id == item._id })
        console.log("index of this element", index);
        if (index == -1) {
          this.unitList.push(obj)
        }
      })
      // this.unitList = finalArray
      this.allUnits = this.unitList
      console.log("output of display array", this.unitList);
      this.createUnitForm()
    })

  }

}
